import initialState from './initialState';
import {
  ENTITY_USE_QUERY_GET_QUERY_INIT,
  ENTITY_USE_QUERY_GET_QUERY_SUCCESS,
  ENTITY_USE_QUERY_GET_QUERY_FAILURE,
  ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_INIT,
  ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_SUCCESS,
  ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_FAILURE,
  ENTITY_USE_QUERY_GET_METRICS_LIST_INIT,
  ENTITY_USE_QUERY_GET_METRICS_LIST_SUCCESS,
  ENTITY_USE_QUERY_GET_METRICS_LIST_FAILURE,
  ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_INIT,
  ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_SUCCESS,
  ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_FAILURE, 
  ENTITY_USE_QUERY_RESET
} from '../../actions/entityUseQuery/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function entityUseQuery(state = initialState, action) {
  switch (action.type) {      
    case ENTITY_USE_QUERY_GET_QUERY_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "queryData");
    case ENTITY_USE_QUERY_GET_QUERY_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "queryData");
    case ENTITY_USE_QUERY_GET_QUERY_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "queryData");
    case ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "dimensionsList");
    case ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "dimensionsList");
    case ENTITY_USE_QUERY_GET_DIMENSIONS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "dimensionsList");
    case ENTITY_USE_QUERY_GET_METRICS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "metricsList");
    case ENTITY_USE_QUERY_GET_METRICS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "metricsList");
    case ENTITY_USE_QUERY_GET_METRICS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "metricsList");
    case ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "polynomialsList");
    case ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "polynomialsList");
    case ENTITY_USE_QUERY_GET_POLYNOMIALS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "polynomialsList");
    case ENTITY_USE_QUERY_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/entityUseQuery/index.js